import { ISettingsState } from '../../setting/interface/setting.interface';

export const initialSettingsState: ISettingsState = {
    settings: null,
};
